import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
  onSuccess: (data: any) => void;
}

export interface IInvoiceSettingsRes {
  finishCustomization: boolean;
}

export const useInvoiceSettingsQuery = ({ customerId, onSuccess }: IProps) => useQuery(
  'InvoiceSettingsQuery',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/invoice/setting`);
    return data;
  },
  {
    retry: 1,
    enabled: true,
    onSuccess: (data: IInvoiceSettingsRes) => {
      onSuccess(data);
    },
  },
);
